export default __webpack_public_path__ + "static/media/img-0493-holy-see-full-face.a2238250.png";